import type { FunctionComponent } from 'react'
import type { CustomArrowProps } from 'react-slick'
import Slider from 'react-slick'

import styles from './bento-one.module.scss'
import BentoPieceRectangle from '@contentful-components/bento-box/pieces/bento-piece-rectangle'
import type { BentoOneFragment } from '@graphql/queries/GetBentoOne.graphql'

export const BentoOne: FunctionComponent<Props> = ({ pieces }) => {
    const NextArrow = ({
        currentSlide,
        slideCount,
        ...props
    }: CustomArrowProps) => <div {...props} />

    const PrevArrow = ({
        currentSlide,
        slideCount,
        ...props
    }: CustomArrowProps) => <div {...props} />

    return (
        <div className={styles.container}>
            <div className={styles.flexContainer}>
                {pieces?.items.length === 1 && (
                    <BentoPieceRectangle rectangle={pieces?.items[0]} />
                )}

                {/* If more than 1 item returned use inside slider element */}
                {pieces && pieces?.items?.length > 1 && (
                    <Slider
                        accessibility
                        autoplay
                        autoplaySpeed={7000}
                        className={styles.carousel}
                        infinite
                        nextArrow={<NextArrow />}
                        prevArrow={<PrevArrow />}
                    >
                        {pieces?.items.map((item, index) => {
                            return (
                                <div key={index}>
                                    <BentoPieceRectangle rectangle={item} />
                                </div>
                            )
                        })}
                    </Slider>
                )}
            </div>
        </div>
    )
}

export default BentoOne

type Props = Omit<BentoOneFragment, 'sys' | 'type'> & {
    index?: number
}
